var _path;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19,13h-6v6h-2v-6H5v-2h6V5h2v6h6v2Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPlus);
export default __webpack_public_path__ + "static/1772534745/media/icon-plus.3a90e42bdd13ad49e3e5c67fb1778fdf.svg";
export { ForwardRef as ReactComponent };